import { http, HttpResponse } from 'msw';

const mockUserMe = [
  http.get(`${process.env.BFF_URL}user/me`, () =>
    HttpResponse.json({
      data: {
        id: 82308,
        name: 'testetechnca1@fretebras.com.br',
        typeDescription: 'Administrador',
        email: 'testetechnca1@fretebras.com.br',
        company: {
          id: 50,
          name: 'fretebras tech nca 1',
          plan: 'M',
          branch: 'Transportadora',
          phones: [
            { ddd: '21', phone_number: '(21) 99974-9899' },
            { ddd: '21', phone_number: '(21) 99974-9999' },
            { ddd: '64', phone_number: '(64) 9889-8888' },
            { ddd: '66', phone_number: '(66) 3567-9999' },
          ],
          activationDate: '2/5/2008 13:01:56',
          tag: 'empresa/testetech-nca-1/catalao-go/ramo-transportadora/1217400/',
          groupId: 0,
          freightsTag: 'fretes/empresa-testetech-nca-1,0',
          combo: {
            uuid: '9433429d-2935-4392-82b4-ee655f4bd63a',
            name: 'Basico',
            renew_day: 22,
            products: [
              {
                slug: 'freight-register-sharing',
                consumption: {
                  limit: 0,
                  consumed: 0,
                  extras: 0,
                  initial: 0,
                  available: 0,
                },
                name: 'Compartilhamento de fretes',
                description: 'Compartilhamento de fretes',
                tooltip: 'Compartilhamento de fretes',
                maxLimitView: 1,
              },
              {
                slug: 'suggested-trucker',
                consumption: {
                  limit: 0,
                  consumed: 0,
                  extras: 0,
                  initial: 0,
                  available: 0,
                },
                name: 'Motoristas sugeridos',
                description: 'Motoristas sugeridos',
                tooltip: 'Motoristas sugeridos',
                maxLimitView: 3,
                price: 19.9,
              },
            ],
          },
        },
      },
    })
  ),
];

export { mockUserMe };
